import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Post from '../views/Post.vue'
import Edit from '../views/Edit.vue'
import Recipes from '../views/Recipes.vue'

Vue.use(VueRouter)

    const routes = [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/recipes/:id',
            name: 'Recipes',
            props: true,
            component: Recipes
        },
        {
            path: '/post',
            name: 'Post',
            props: true,
            component: Post
        },
        {
            path: '/edit/:id',
            name: 'Edit',
            props: true,
            component: Edit
        }
    ]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
})

router.onReady(() => {
    router.afterEach((to) => {
        window.gtag('config', window.gtmid, {'page_path': to.fullPath})
    })
})

export default router
